var App = App || {};

App.BlockTabs = (function () {
    'use strict';

    function initializeTabs() {
        // Tabs behavior is handled by Bootstrap's native tab/collapse data APIs.
    }

    return {
        initializeTabs
    };
})();
